
import { bindActionCreators } from 'redux';
import { connect }            from 'react-redux';
import * as actions           from '../../redux/modules/actions';
import TodoListView           from './TodoListView';

const mapStateToProps = (state) => {
  return {
    currentView:  state.views.currentView
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions : bindActionCreators(
      {
        enterTodoListView: actions.enterTodoListView,
        leaveTodoListView: actions.leaveTwitterFeed
      },
      dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TodoListView);



// WEBPACK FOOTER //
// ./src/app/views/todoList/index.js